import clsx from 'clsx'
import React from 'react'

import { Text } from '@wartek-id/text'

import type { QuestionIndicatorProps } from 'types/microlearning'

const QuestionIndicator = ({
  currentIndex,
  totalQuestions,
}: QuestionIndicatorProps): JSX.Element => {
  return (
    <div className="mb-6">
      <div className="mb-2">
        <Text variant="body-sm" color="default">
          Soal {currentIndex + 1} dari {totalQuestions}
        </Text>
      </div>
      <div className="flex -mx-1 items-center">
        {[...Array(totalQuestions)].map((_, i) => {
          return (
            <div className="flex-auto px-1" key={i}>
              <div
                className={clsx(
                  'h-2 rounded border',
                  i > currentIndex && 'border-subdued bg-interactive-disabled',
                  i <= currentIndex && 'bg-primary border-primary'
                )}
              />
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default QuestionIndicator
